export const DateLabels = {
  ACTUAL_DATE: 'Actual Date',
  SCHEDULED_DATE: 'Scheduled Date',
  REQUESTED_DATE: 'Requested Date',
  ESTIMATED_DELIVERY: 'Estimated Delivery',
  ESTIMATED_FIRST_DELIVERY: 'Estimated First Delivery',
  ESTIMATED_NEXT_DELIVERY: 'Estimated Next Delivery',
  ESTIMATED_DELIVERY_IN_FULL: 'Estimated Delivery in Full',
  FIRST_DELIVERY_MADE_ON: 'First Delivery Made On',
  MOST_RECENT_DELIVERY_MADE_ON: 'Most Recent Delivery Made On',
  DELIVERED_IN_FULL: 'Delivered in Full',
  DELIVERED: 'Delivered',
  REQUESTED: 'Requested',
};
